<template>
  <div class="setting-container">
    <div class="list">
      <router-link to="/transcation.html" class="item">
        <span class="name">交易记录</span>
        <img src="~@/assets/img/arrow-enter.png" alt="" class="enter" />
      </router-link>
      <router-link to="/likeDetail.html" class="item">
        <span class="name">“喜欢”明细</span>
        <img src="~@/assets/img/arrow-enter.png" alt="" class="enter" />
      </router-link>
      <p class="item" @click="triggerPicker">
        <span class="name">感情状态</span>
        <span class="value">
          {{statusMap[userData.singleStatus]}}
          <img src="~@/assets/img/arrow-enter.png" alt="" class="enter" />
        </span>
      </p>
      <router-link to="/agreement.html" class="item">
        <span class="name">用户须知</span>
        <img src="~@/assets/img/arrow-enter.png" alt="" class="enter" />
      </router-link>
      <router-link to="/aboutus.html" class="item">
        <span class="name">关于我们</span>
        <img src="~@/assets/img/arrow-enter.png" alt="" class="enter" />
      </router-link>
    </div>

    <a href="javascript:;" @click="logout" class="logout-btn">退出</a>

    <van-dialog
      id="status-dialog"
      v-model="isShowDialog"
      :message="'1、当您的感情状态改为脱单后，他人无法查看到您的资料，同时您也无法查看别人的资料。\n2、感情状态的修改间隔不得少于7天，请慎重操作。'"
      confirmButtonText="知道了"
      @confirm="confirmDialog"
    ></van-dialog>

    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :visible-item-count="3"
        :columns="statusColumns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
      />
    </van-popup>

  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { delCookie } from '@/utils/tools'
export default {
  name: 'setting',
  data () {
    return {
      isShowDialog: false,
      showPicker: false
    }
  },
  computed: {
    ...mapState({
      userData: 'userData',
      statusMap: 'statusMap'
    }),
    ...mapGetters({
      userId: 'userId'
    }),
    statusColumns () {
      let arr = []
      for (let i in this.statusMap) {
        arr.push({
          value: i,
          text: this.statusMap[i]
        })
      }
      // 去掉不限状态
      arr.shift(0)
      return arr
    }
  },
  methods: {
    ...mapMutations({
      updateUserData: 'updateUserData'
    }),
    triggerPicker () {
      this.isShowDialog = true
    },
    confirmDialog () {
      this.showPicker = true
    },
    onConfirm (val) {
      let value = parseInt(val.value)
      this.$root.openLoading()
      this.$http('/api/member/updateSingleStatus', {
        singleStatus: value
      }).then(res => {
        this.$root.closeLoading()
        if (res.code === '0000') {
          // TODO: 更新个人信息
          this.updateUserData({
            singleStatus: value
          })
          this.showPicker = false
        } else {
          this.$toast(res.msg)
        }
        this.showPicker = false
      }, err => {
        this.$root.closeLoading()
        this.$toast(err)
      })
    },
    logout () {
      delCookie('session')
      delCookie('session', '.hellobuluo.com')
      localStorage.removeItem('session')
      localStorage.setItem("isExit", "true");
      location.href = location.origin
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/constant.scss";
.setting-container {
  .list {
    padding-left: 40px;
    border-bottom: 1px solid #e5e5e5;
  }
  .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 40px 50px 40px 0;
    .name,
    .value {
      color: #9B9BA1;
      font-size: 32px;
    }
    & + .item {
      border-top: 1px solid #e5e5e5;
    }
  }
  .enter {
    width: 14px;
  }
  .logout-btn {
    position: fixed;
    bottom: 60px;
    left: 50%;
    padding: 25px;
    width: 590px;
    color: $mainColor;
    font-size: 36px;
    line-height: 50px;
    border-radius: 50px;
    text-align: center;
    border: 1px solid $mainColor;
    transform: translateX(-50%);
  }
}
</style>
